import React, { useState } from 'react';
import { useModalDismiss } from '../../hooks/useModalDismiss';

interface PasswordInputModalProps {
  title: string;
  message: string;
  onConfirm: (password: string) => void;
  onCancel: () => void;
  error?: string;
}

export function PasswordInputModal({ title, message, onConfirm, onCancel, error }: PasswordInputModalProps) {
  const [password, setPassword] = useState('');
  const dismiss = useModalDismiss(onCancel);

  const handleConfirm = () => {
    onConfirm(password);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleConfirm();
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'var(--modal-mask)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001,
      backdropFilter: 'blur(4px)'
    }} {...dismiss}>
      <div style={{
        backgroundColor: 'var(--card-bg)', padding: 32, borderRadius: 24, width: 420,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', color: 'var(--text-color)'
      }}>
        <h2 style={{ marginBottom: 12, fontSize: 18, fontWeight: 800 }}>{title}</h2>
        <p style={{ marginBottom: 20, color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6 }}>
          {message}
        </p>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="请输入密码"
          autoComplete="new-password"
          name="export-import-password"
          data-lpignore="true"
          data-1p-ignore
          style={{ 
            width: '100%', padding: '14px 18px', marginBottom: error ? 8 : 24, boxSizing: 'border-box', 
            border: error ? '2px solid var(--danger-color)' : '2px solid var(--border-color)', 
            backgroundColor: 'var(--bg-color)', color: 'var(--text-color)', borderRadius: 12, fontSize: 16,
            transition: 'border-color 0.2s'
          }}
        />
        {error && (
          <div style={{ color: 'var(--danger-color)', marginBottom: 16, fontSize: 13, fontWeight: 600 }}>
            {error}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button 
            onClick={onCancel} 
            style={{ 
              padding: '12px 24px', backgroundColor: 'transparent', color: 'var(--text-secondary)', 
              border: 'none', borderRadius: 12, cursor: 'pointer', fontSize: 15, fontWeight: 600 
            }}
          >
            取消
          </button>
          <button 
            onClick={handleConfirm}
            disabled={!password.trim()}
            style={{ 
              padding: '12px 32px', backgroundColor: 'var(--primary-color)', color: 'white', 
              border: 'none', borderRadius: 12, 
              cursor: password.trim() ? 'pointer' : 'not-allowed', fontSize: 15, fontWeight: 700,
              boxShadow: password.trim() ? '0 10px 15px -3px rgba(24, 144, 255, 0.4)' : 'none',
              opacity: password.trim() ? 1 : 0.6
            }}
          >
            确认
          </button>
        </div>
      </div>
    </div>
  );
}
